import { Component, Input, OnInit } from "@angular/core";
import { ChannelJsonEditorViewModel } from "./channel-json-editor.view-model";

@Component({
  selector: "evrideo-channel-json-editor",
  templateUrl: "./channel-json-editor.component.html",
  styleUrls: ["./channel-json-editor.component.scss"],
})
export class ChannelJsonEditorComponent implements OnInit {
  @Input()
  vm: ChannelJsonEditorViewModel;
  constructor() {}

  ngOnInit(): void {}
}
